import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MasterService } from '../../../base-classes/master-service';
import { UserClientMappingViewModel } from '../viewmodels/user-client-mapping-viewmodel';

@Injectable({
    providedIn: 'root'
})
export class UserClientService extends MasterService<UserClientMappingViewModel> {
    constructor(http: HttpClient) {
        const baseUrl = `${environment.apiUrl}/user-clients`;
        super(http, baseUrl);
    }

    public getClientList() {
        return this.http.get<any[]>(`${environment.apiUrl}/clients`);
    }

    public getUserList() {
        return this.http.get<any[]>(`${environment.apiUrl}/users`);
    }

    public createUserClients(item: Partial<any>): Observable<any> {
            return this.http.post<any>(`${environment.apiUrl}/user-clients`, item);
    }

     public getUserClients(){
            return this.http.get<any[]>(`${environment.apiUrl}/user-clients`);
    }

    public getUserClientById(id: string) {
        return this.http.get<any[]>(`${environment.apiUrl}/user-clients/${id}`);
    }

}